module.exports = __webpack_public_path__ + "static/img/noticia6.53996df3.jpeg";